import { render, staticRenderFns } from "./LeyendaColorAnexa.vue?vue&type=template&id=4addba8c&scoped=true"
var script = {}
import style0 from "./LeyendaColorAnexa.vue?vue&type=style&index=0&id=4addba8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4addba8c",
  null
  
)

export default component.exports